import {
  AutocompleteModule,
  ButtonsModule,
  DatepickerModule,
  PaginationMapsModule,
  ToastModule
} from "maps-angular-components";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {AutocompleteLibModule} from "angular-ng-autocomplete";
import {CadastroRegraComponent} from "./cadastro-regra/cadastro-regra.component";
import {CommonModule} from "@angular/common";
import {CurrencyMaskModule} from "ng2-currency-mask";
import {DatepickerEnquadramentoModule} from "../shared/components/datepicker/datepicker-enquadramento.module";
import {FuncaoModule} from "../funcao/funcao.module";
import {GerenciadorRegistroComponent} from "./gerenciador-registro/gerenciador-registro.component";
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatButtonModule} from "@angular/material/button";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatDialogModule} from "@angular/material/dialog";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatSelectModule} from "@angular/material/select";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {MatSnackBarModule} from "@angular/material/snack-bar";
import {MatStepperModule} from "@angular/material/stepper";
import {MatTabsModule} from "@angular/material/tabs";
import {
  ModalDeletarRegraDialogComponent
} from "./gerenciador-registro/modal-deletar-regra/modal-deletar-regra.component";
import {ModalEditarRegraDialogComponent} from "./gerenciador-registro/modal-editar-regra/modal-editar-regra.component";
import {NgModule} from "@angular/core";
import {NgStringPipesModule} from "ngx-pipes";
import {ParamDirective} from "./cadastro-regra/param.directive";
import {ParametroFuncaoComponent} from "./cadastro-regra/parametro-funcao/parametro-funcao.component";
import {
  ParametroFuncaoCompostoComponent
} from './cadastro-regra/parametro-funcao/parametro-funcao-composto/parametro-funcao-composto.component';
import {
  ParametroFuncaoPercentualComponent
} from './cadastro-regra/parametro-funcao/parametro-funcao-percentual/parametro-funcao-percentual.component';
import {
  ParametroFuncaoValorFinanceiroComponent
} from './cadastro-regra/parametro-funcao/parametro-funcao-valor-financeiro/parametro-funcao-valor-financeiro.component';
import {RegraCompostaComponent} from "./regra-composta/regra-composta.component";
import {RegraCompostaStepperComponent} from "./regra-composta/regra-composta-stepper/regra-composta-stepper.component";
import {RegraService} from "./regra.service";
import {RegraSimplesComponent} from "./regra-simples/regra-simples.component";
import {SelecaoRegrasComponent} from "./selecao-regras/selecao-regras.component";
import {SharedModule} from "../shared/shared.module";
import {TabsModule} from "ngx-bootstrap";
import {MatMenuModule} from "@angular/material/menu";
import {
  ParametroFuncaoValorInteiroComponent
} from "./cadastro-regra/parametro-funcao/parametro-funcao-valor-inteiro/parametro-funcao-valor-inteiro.component";
import {
  ParametroFuncaoValorCheckboxComponent
} from "./cadastro-regra/parametro-funcao/app-parametro-funcao-valor-checkbox/parametro-funcao-valor-checkbox.component";
import {
  ParametroFuncaoValorBooleanComponent
} from './cadastro-regra/parametro-funcao/parametro-funcao-valor-boolean/parametro-funcao-valor-boolean.component';
import {AutocompleteMultiselectModule} from "../generic-autocomplete/autocomplete-multiselect.module";

@NgModule({
    declarations: [
        RegraSimplesComponent,
        CadastroRegraComponent,
        ParamDirective,
        ParametroFuncaoComponent,
        ModalDeletarRegraDialogComponent,
        ModalEditarRegraDialogComponent,
        RegraCompostaComponent,
        RegraCompostaStepperComponent,
        GerenciadorRegistroComponent,
        SelecaoRegrasComponent,
        ParametroFuncaoPercentualComponent,
        ParametroFuncaoCompostoComponent,
        ParametroFuncaoValorFinanceiroComponent,
        ParametroFuncaoValorInteiroComponent,
        ParametroFuncaoValorCheckboxComponent,
        ParametroFuncaoValorBooleanComponent
    ],
    imports: [
        CommonModule,
        TabsModule,
        ReactiveFormsModule,
        MatSelectModule,
        MatDialogModule,
        MatCheckboxModule,
        ButtonsModule,
        AutocompleteModule,
        AutocompleteLibModule,
        FormsModule,
        SharedModule,
        MatStepperModule,
        MatSlideToggleModule,
        PaginationMapsModule,
        NgStringPipesModule,
        MatButtonModule,
        DatepickerModule,
        DatepickerEnquadramentoModule,
        CurrencyMaskModule,
        MatInputModule,
        MatFormFieldModule,
        MatTabsModule,
        MatSnackBarModule,
        ToastModule.forRoot(),
        MatAutocompleteModule,
        AutocompleteMultiselectModule,
        DatepickerModule,
        FuncaoModule,
        MatMenuModule
    ],
    exports: [
        RegraSimplesComponent,
        RegraCompostaComponent,
        GerenciadorRegistroComponent,
        SelecaoRegrasComponent,
        CadastroRegraComponent,
    ],
    providers: [RegraService],
    entryComponents: [
        ModalDeletarRegraDialogComponent,
        ModalEditarRegraDialogComponent,
    ],
})
export class RegraModule {
}
